<template>
  <v-row>
    <v-col xs="12" sm="12" md="12" lg="6" class="pa-0">
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Waterway_On/Under_${rowId}`"
        label="F.02 On/Under"
        :refTable="REFERENCE_TABLE.ON_UNDER"
        v-model="selectedRow.onUnder"
      >
      </LabelSelect>
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Waterway_Feature_Type_${rowId}`"
        label="F.03 Feature Type"
        v-if="$vuetify.display.mdAndDown"
        :refTable="REFERENCE_TABLE.FEATURE_TYPE"
        v-model="selectedRow.featureType"
      >
      </LabelSelect>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Stream_Name_${rowId}`"
        label="WD.01 Stream Name"
        v-model="selectedRow.roadwayName"
        maxlength="30"
      >
      </LabelText>

      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Stream_Classification_1_${rowId}`"
        label="WD.02 Stream Classification 1"
        :refTable="REFERENCE_TABLE.STREAM_CLASSIFICATION"
        v-model="selectedRow.depClass1"
      >
      </LabelSelect>
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Stream_Classification_2_${rowId}`"
        label="WD.03 Stream Classification 2"
        :refTable="REFERENCE_TABLE.STREAM_CLASSIFICATION"
        v-model="selectedRow.depClass2"
      >
      </LabelSelect>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Timeframe_${rowId}`"
        label="WD.04 Timeframe"
        v-model="selectedRow.depTimeframe"
        maxlength="25"
      >
      </LabelText>

      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Stream_Classification_3_${rowId}`"
        label="WD.05 Stream Classification 3"
        :refTable="REFERENCE_TABLE.STREAM_CLASSIFICATION"
        v-model="selectedRow.depClass3"
      >
      </LabelSelect>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Permit_Type_${rowId}`"
        label="WD.06 Permit Type"
        v-model="selectedRow.depPermitType"
        maxlength="10"
      >
      </LabelText>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Drainage_Area_${rowId}`"
        label="WD.07 Drainage Area"
        appendWith=" sq mi."
        type="number"
        :decimalPlaces="1"
        maxlength="8"
        :rules="
          isEditable
            ? [
                (value) => {
                  return valueInRangeRule(value, -1, 999999.9);
                },
              ]
            : []
        "
        v-model="selectedRow.streamDrainArea"
      >
      </LabelText>

      <LabelCheckbox
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        :id="`txt_Fishable_${rowId}`"
        label="WD.08 Fishable"
        v-model="selectedRow.fishable"
      >
      </LabelCheckbox>

      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Waterflow_Direction_${rowId}`"
        label="WD.09 Waterflow Direction"
        :refTable="REFERENCE_TABLE.WATERFLOW_DIRECTION"
        v-model="selectedRow.waterflowDir"
      >
      </LabelSelect>
    </v-col>
    <v-col class="pa-0">
      <LabelSelect
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :selectXl="6"
        :selectLg="6"
        :selectMd="6"
        :selectSm="6"
        :id="`label_Waterway_Feature_Type_${rowId}`"
        label="F.03 Feature Type"
        v-if="$vuetify.display.lgAndUp"
        :refTable="REFERENCE_TABLE.FEATURE_TYPE"
        v-model="selectedRow.featureType"
      >
      </LabelSelect>

      <LabelCheckbox
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        :id="`txt_Primary_Waterway_${rowId}`"
        label="WD.10 Primary Waterway"
        v-model="selectedRow.primaryWaterway"
      >
      </LabelCheckbox>

      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Vertical_Clearance_${rowId}`"
        label="WD.11 Vertical Clearance"
        appendWith=" ft"
        type="number"
        :decimalPlaces="1"
        v-model="selectedRow.minOverVertClearRight"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Max_W_S_Elevation_${rowId}`"
        label="WD.12 Max W.S. Elevation"
        appendWith=" ft"
        v-model="selectedRow.maxWaterSurfElev"
        type="number"
        :decimalPlaces="1"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Max_W_S_Elevation_Year_${rowId}`"
        label="WD.13 Max W.S. Elevation Year"
        v-model="selectedRow.maxWaterSurfYear"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Design_Flood_Magnitude_${rowId}`"
        label="WD.14 Design Flood Magnitude"
        appendWith=" cf/s"
        v-model="selectedRow.designFloodMagnitude"
        type="number"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Design_Flood_Elevation_${rowId}`"
        label="WD.15 Design Flood Elevation"
        appendWith=" ft"
        v-model="selectedRow.designFloodElev"
        type="number"
        :decimalPlaces="1"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Design_Flood_Frequency_${rowId}`"
        label="WD.16 Design Flood Frequency"
        appendWith=" yrs"
        v-model="selectedRow.designFloodFreq"
        type="number"
      >
      </LabelText>
      <LabelText
        :labelXl="6"
        :labelLg="6"
        :labelMd="6"
        :labelSm="6"
        :textXl="6"
        :textLg="6"
        :textMd="6"
        :textSm="6"
        :id="`txt_Design_Flood_Velocity_${rowId}`"
        label="WD.17 Design Flood Velocity"
        appendWith=" fps"
        v-model="selectedRow.designFloodVel"
        type="number"
        :decimalPlaces="1"
      >
      </LabelText>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="12" class="pa-0">
      <LabelText
        labelXl="3"
        labelLg="3"
        labelMd="3"
        labelSm="3"
        textXl="9"
        textLg="9"
        textMd="9"
        textSm="9"
        :id="`txt_Pollutant_Description_${rowId}`"
        label="WD.18 Pollutant Description"
        v-model="selectedRow.pollutantDesc"
        maxlength="200"
        type="textarea"
        counter
        persistentCounter
        class="pb-0 customLabelAlignment"
      >
      </LabelText>

      <LabelText
        labelXl="3"
        labelLg="3"
        labelMd="3"
        labelSm="3"
        textXl="9"
        textLg="9"
        textMd="9"
        textSm="9"
        :id="`txt_Stream_Restrict_Description_${rowId}`"
        label="WD.19 Stream Restrict Description"
        v-model="selectedRow.streamRestrictDesc"
        maxlength="200"
        type="textarea"
        counter
        persistentCounter
        class="pb-0 customLabelAlignment"
      >
      </LabelText>

      <LabelText
        labelXl="3"
        labelLg="3"
        labelMd="3"
        labelSm="3"
        textXl="9"
        textLg="9"
        textMd="9"
        textSm="9"
        :id="`txt_FW20_Notes_${rowId}`"
        label="WD.20 Notes"
        v-model="selectedRow.notes"
        maxlength="2000"
        type="textarea"
        counter
        persistentCounter
        class="pb-0 customLabelAlignment"
      >
      </LabelText>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from "vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import LabelText from "@/components/common/LabelText.vue";
import { valueInRangeRule } from "@/composables/validationRules";

export default {
  name: "InspectionFeaturesWaterway",
  props: {
    rowId: { default: 0 },
  },
  setup(props) {
    const inspectionStore = useInspectionStore();

    let selectedRow = computed(() => inspectionStore.getFeatureIntersectionSelectedRow(props.rowId));

    return {
      REFERENCE_TABLE,
      selectedRow,
      valueInRangeRule,
    };
  },
  components: {
    LabelSelect,
    LabelCheckbox,
    LabelText,
  },
};
</script>
